/* ===============================================
   Custom Subscribe-&-Save UI for Seal Subscriptions
   =============================================== */

(function () {
  /* 1.  Map of selling-plan IDs → label text */
  const plans = [
    { id: "639270982", text: "3 months" },
    { id: "639303750", text: "4 months" },
    { id: "639336518", text: "5 months" },
    { id: "639369286", text: "6 months" },
    { id: "639402054", text: "8 months" },
    { id: "639434822", text: "12 months" },
  ];

  /* 2.  Build our checkbox + dropdown and attach listeners */
  function buildCustomUI(sealWidget) {
    if (document.getElementById("custom-subscribe-ui")) return; // already injected
    
    /* ---------- HTML shell ---------- */
    const wrapper = document.createElement("div");
    wrapper.id = "custom-subscribe-ui";
    wrapper.innerHTML = `
      <div style="margin:1em 0;">
        <label style="cursor:pointer;display:flex;align-items:center;gap:.5em;">
          <input type="checkbox" id="subscribeToggle">
          <strong id="subscribeLabel">Subscribe and pay</strong>
        </label>
      </div>
      <div id="intervalDropdownWrapper" style="display:none;margin-bottom:1em;">
        <label for="intervalSelect">Ship every&nbsp;</label>
        <select id="intervalSelect"></select>
      </div>
    `;
    /* ---------- Dynamic label: "Subscribe and pay $X.XX" ---------- */
    (function attachPriceObserver () {
      const labelEl = wrapper.querySelector('#subscribeLabel');
      if (!labelEl) return;
    
      // pull price and update label
      const refreshLabel = () => {
        const priceSpan = sealWidget.querySelector(
          '.sls-selling-plan-group-price .money'
        );
        if (priceSpan) {
          const price = priceSpan.textContent.trim().replace(/^CA\s*/i, '');
          labelEl.textContent = `Subscribe and pay ${price}`;
          return true;
        }
        return false;
      };
    
      // try once immediately
      if (refreshLabel()) return;
    
      // keep watching until price appears, then stop
      const mo = new MutationObserver(() => {
        if (refreshLabel()) mo.disconnect();
      });
      mo.observe(sealWidget, { childList: true, subtree: true });
    })();


    sealWidget.insertAdjacentElement("afterend", wrapper);

    /* ---------- Populate dropdown ---------- */
    const dropdown = wrapper.querySelector("#intervalSelect");
    plans.forEach(p => {
      const o = document.createElement("option");
      o.value = p.id;
      o.textContent = p.text;
      dropdown.appendChild(o);
    });

    /* ---------- Grab hidden Seal controls ---------- */
    const oneTimeRadio = sealWidget.querySelector('input[data-type="one_time"]');
    const subRadio     = sealWidget.querySelector('input[data-type="subscription"]');
    const sealSelect   = sealWidget.querySelector('select.sls-select');

    if (!oneTimeRadio || !subRadio || !sealSelect) {
      console.warn("Seal elements missing – UI not wired");
      return;
    }

    /* ---------- Helper to sync dropdown → Seal select ---------- */
    function syncIntervalToSeal(id) {
      sealSelect.value = id;
      // trigger built-in change handlers
      sealSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    /* ---------- Checkbox listener ---------- */
    const toggle = wrapper.querySelector("#subscribeToggle");
    toggle.addEventListener("change", () => {
      if (toggle.checked) {
        subRadio.click();                         // activate subscription
        wrapper.querySelector("#intervalDropdownWrapper").style.display = "block";
        syncIntervalToSeal(dropdown.value);       // ensure interval matches
      } else {
        oneTimeRadio.click();                     // revert to one-time
        wrapper.querySelector("#intervalDropdownWrapper").style.display = "none";
      }
    });

    /* ---------- Dropdown listener ---------- */
    dropdown.addEventListener("change", () => {
      if (!toggle.checked) return;                // safety
      syncIntervalToSeal(dropdown.value);
    });

    /* ---------- Initial state sync ---------- */
    if (subRadio.checked) {                       // page might load pre-checked
      toggle.checked = true;
      wrapper.querySelector("#intervalDropdownWrapper").style.display = "block";
      // mirror Seal’s current value into our dropdown
      dropdown.value = sealSelect.value;
    }
  }

  /* 3.  Wait for Seal widget (it’s injected after page load) */
  function tryInject() {
    const widget = document.querySelector(".sealsubs-container");
    if (widget) buildCustomUI(widget);
  }
  tryInject();                                   // run once
  new MutationObserver(tryInject)                // run again if widget appears later
      .observe(document.body, { childList: true, subtree: true });

  /*4. */
  function refreshSubscribeUI() {
    const oldUI = document.getElementById("custom-subscribe-ui");
    if (oldUI) oldUI.remove();
  
    setTimeout(() => {
      const sealWidget = document.querySelector(".sealsubs-container");
      if (sealWidget) buildCustomUI(sealWidget);
      else console.warn("[Subscribe UI] Seal widget not found after variant change");
    }, 300); // Delay lets Seal re-render its widget
  }
  
  document.addEventListener('variant:change', () => {
    console.log('[Subscribe UI] variant:change detected');
    refreshSubscribeUI();
  });



})();
